import { Screen } from '../components/Screen.js';
import { EmptyState, Panel } from '../components/ui.js';

/**
 * Support > Knowledgebase (Jon, 2026-10-11): a placeholder for the articles
 * people will read before they write in. Nothing behind it yet.
 */
export function Knowledgebase() {
  return (
    <Screen>
      <Panel title="Knowledgebase">
        <EmptyState
          title="The knowledgebase is not built yet."
          suggestion="Articles people can read before opening a ticket will be written and published here."
        />
      </Panel>
    </Screen>
  );
}
